import { Alert, Stack } from "@caspeco/casper-ui-library";
import { RichTextRenderer } from "components/rich-text-renderer";
import { PhoneNumberLink } from "components/links/phone-number-link";
import { SafeHTML } from "components/safe-html";
import InformationOnlyExperience from "components/selection-components/select-time/information-only-experience";
import i18n, { t } from "i18next";
import { AvailableTimesSection, AvailableTimesUnit } from "types/available-times";
import { Experience } from "types/experience";
import { RichTextField, resolveRichTextField } from "types/rich-text-field";
import { WebRule } from "types/web-rule";

const isOpenTextRow = (timeSet: WebRule) => timeSet.isTextRow && !timeSet.isClosed;

export function BookingClosed({
    units,
    informationOnlyExperiences = [],
    messageBookingClosed,
    messageBookingClosedTemplate,
}: {
    units: AvailableTimesUnit[];
    informationOnlyExperiences?: Experience[];
    messageBookingClosed?: string;
    messageBookingClosedTemplate?: RichTextField;
}) {
    const hasTextRules = units.some((unit: AvailableTimesUnit) => {
        return unit.sections.some((section: AvailableTimesSection) => {
            return section.timeSets.some(isOpenTextRow);
        });
    });

    type SectionWithTextRule = {
        section: AvailableTimesSection;
        timeSet: WebRule;
    };

    const showTextRules = () => {
        const rules: SectionWithTextRule[] = [];
        units.forEach((unit: AvailableTimesUnit) => {
            unit.sections.forEach((section: AvailableTimesSection) => {
                section.timeSets.forEach((timeSet) => {
                    if (isOpenTextRow(timeSet)) {
                        rules.push({ section, timeSet });
                    }
                });
            });
        });

        return rules.map((rule: SectionWithTextRule) => {
            return (
                <Alert
                    key={rule.timeSet.id}
                    title={rule.timeSet.title}
                    type="info"
                    iconVerticalAlign={"flex-start"}
                >
                    <SafeHTML element="div" html={rule.timeSet.comment} />
                </Alert>
            );
        });
    };

    return (
        <Stack>
            {messageBookingClosedTemplate ? (
                <Alert key="messageBookingClosed" type="info" iconVerticalAlign={"flex-start"}>
                    <RichTextRenderer
                        content={resolveRichTextField(messageBookingClosedTemplate, i18n.language)}
                    />
                </Alert>
            ) : !messageBookingClosed ? (
                <Alert type="info" title={t("start.dayClosed")}>
                    <PhoneNumberLink />
                </Alert>
            ) : (
                <Alert key="messageBookingClosed" type="info" iconVerticalAlign={"flex-start"}>
                    <SafeHTML element="div" html={messageBookingClosed} />
                </Alert>
            )}
            {informationOnlyExperiences.map((experience, index) => (
                <InformationOnlyExperience
                    key={`experience-${experience.id}`}
                    experience={experience}
                    isFirstExperience={index === 0}
                />
            ))}
            {hasTextRules && showTextRules()}
        </Stack>
    );
}
